function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import CardComponent from "./card/card-component";
import FactDetailsComponent from "./fact-details/fact-details-component";
import FactQuoteComponent from "./fact-quote/fact-quote-component";
import { StyledFactCardComponent } from "./fact-card-component.scss";
class FactCardComponent extends PureComponent {
    render() {
        const { width, height, detailsCard, quoteCard } = this.props;
        const detailsCardBackground = detailsCard.background;
        const quoteCardBackground = quoteCard.background;
        return /*#__PURE__*/ _jsxs(StyledFactCardComponent, {
            className: "fact-card-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "fact-details-wrapper",
                    children: /*#__PURE__*/ _jsx(CardComponent, {
                        width: width,
                        height: height,
                        background: detailsCardBackground,
                        children: /*#__PURE__*/ _jsx(FactDetailsComponent, _object_spread({}, detailsCard))
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "fact-quote-wrapper",
                    children: /*#__PURE__*/ _jsx(CardComponent, {
                        width: width,
                        height: height,
                        background: quoteCardBackground,
                        children: /*#__PURE__*/ _jsx(FactQuoteComponent, _object_spread({}, quoteCard))
                    })
                })
            ]
        });
    }
    constructor(props){
        super(props);
    }
}
export { FactCardComponent as default };
FactCardComponent.defaultProps = {
    detailsCard: {},
    quoteCard: {}
};
